module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_studio@3x-be9e2e29968eee813d574ec418b8aa83.webp";